"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Gevorg Avetisyan on 12/3/2018.
 */
var CommonUtil = /** @class */ (function () {
    function CommonUtil() {
    }
    CommonUtil.toMap = function (json) {
        var map = new Map();
        for (var k in json) {
            map.set(Number(k), json[k]);
        }
        return map;
    };
    return CommonUtil;
}());
exports.CommonUtil = CommonUtil;
//# sourceMappingURL=common.util.js.map